import { CurrencyCodeType } from '@/types/currency';
import { SimplifiedTransactionStatus, TransactionType } from '@/types/transaction';

export interface GetTransactionsFilters {
  readonly id: string;
  readonly type: TransactionType;
  readonly status: SimplifiedTransactionStatus;
  readonly fromDate: string;
  readonly toDate: string;
  readonly amount: number | '';
  readonly currency: string;
  readonly recipientId: string;
  readonly beneficiaryId: string;
  readonly onlyWithIntegratorSpread: boolean;
  readonly awaitingFunding?: boolean;

  readonly page: number;
  readonly size: number;
  readonly sort: readonly string[] | string;
}

export class GetTransactionsFilters {
  public static initial(): GetTransactionsFilters {
    return veryConstInitialTransactionsFilter;
  }
}

const veryConstInitialTransactionsFilter: GetTransactionsFilters = {
  id: '',
  type: TransactionType.ALL,
  status: SimplifiedTransactionStatus.ALL,
  fromDate: '',
  toDate: '',
  amount: '',
  currency: CurrencyCodeType.ANY,
  recipientId: '',
  beneficiaryId: '',
  onlyWithIntegratorSpread: false,
  page: 0,
  size: 10,
  sort: [],
};
